<template>
	<panel-template>
		<template #bradcrumbs>
			<ui-breadcrumbs design="full" :container="false">
				<template #left>
					Transferência de Reservas
				</template>
			</ui-breadcrumbs>
		</template>

		<template #content>
			<div v-if="loadOverlay" class="load-overlay">
				<ui-load-indicator bg-color="#D1CFDF" color="#0091FF" :h="50" :stroke="8" />
			</div>

			<div v-else class="content-transfer-reservations">
				<div class="icon-square">
					<ui-square-th-one fill="#fff" width="24px" />
				</div>

				<span class="title-transfer-reservations">Transferência de Reservas</span>

				<span class="subtitle-transfer-reservations">
					Transfira uma reserva para outro negócio de maneira segura, mantendo a unidade indisponível durante o processo.
				</span>

				<div class="container-transfer-list">
					<ui-transfer-list
						origin-message="1. Selecione o Negócio Desejado."
						target-message="2. Selecione o Negócio Desejado."
						bg-title="#0091FF"
						container-min-height="443px"
						:icon-origin="false"
						:icon-target="false"
						:input-container="false"
						:to-left-action="handleToLeftAction"
						:to-right-action="handleToRightAction"
						:active-right-action="activeRightAction"
						:active-left-action="activeLeftAction"
						:actions-disable-left="actionsDisableLeft"
						:actions-disable-right="actionsDisableRight"
						:actions-disable="actionsDisable"
						:originsList="true"
						:targetLists="true"
					>
						<template #originAction>
							<div v-if="!hasBusinessOrigin" class="container-origin-target-action">
								<ui-input
									type="text"
									size="md"
									placeholder="Digite nome, e-mail, telefone ou CPF do cliente"
									v-model="form.nameOrigin"
									@keyup.enter="checkDuplicity()"
								/>
								<em v-if="!loadingOrigin" class="fal fa-search search-origin" @click="checkDuplicity()" />

								<div v-if="loadingOrigin" class="loading-area-origin">
									<ui-load-indicator bg-color="#D1CFDF" color="#0091FF" :h="20" :stroke="6" />
								</div>
							</div>

							<div v-if="required && !hasBusinessOrigin" class="container-select">
								<div class="container-select-deal-found scroll-color-primary">
									<div
										v-for="(data, index) in customersDuplicityFound"
										:key="index"
										class="found"
										@click="handleSelectedFound(data)"
									>
										<span class="id-name">{{ data.id }} - {{ data.customer_name }}</span>
										<span v-if="data.customer_cpf" class="cpf">CPF: {{ data.customer_cpf ? formatedCPF(data.customer_cpf) : '-' }}</span>
									</div>
								</div>
							</div>

							<div v-if="hasBusinessOrigin" class="container-select-deal">
								<div class="id-name-cpf">
									<span class="id-name">{{ isSelectedOrigin.id }} - {{ isSelectedOrigin.customer_name }}</span>
									<span v-if="isSelectedOrigin.customer_cpf" class="cpf">CPF: {{ isSelectedOrigin.customer_cpf ? formatedCPF(isSelectedOrigin.customer_cpf) : '-' }}</span>
								</div>

								<span
									class="alter"
									:class="{ 'disabled': isDisabledOrigin }"
									@click="alterFound"
								>
									Alterar
								</span>
							</div>

							<div v-if="reservesDealOrigin.length > 0" class="has-reserves">
								<span class="text-has-reserves">
									Encontramos {{ reservesDealOrigin.length }} {{ reservesDealOrigin.length > 1 ? 'Reservas' : 'Reserva' }}
								</span>
							</div>

							<div v-if="!hasOriginReserves" class="has-reserves">
								<span class="text-has-reserves">
									Nenhuma reserva encontrada.
								</span>
							</div>
						</template>

						<template #originLists>
							<div v-if="loadingOriginSelected" class="loading-area">
								<ui-load-indicator bg-color="#D1CFDF" color="#69D296" :h="50" :stroke="8" />
							</div>

							<div v-if="reservesDealOrigin.length > 0 && !loadingOrigin"  class="container-scroll">
								<div class="container-target-list scroll-color-primary">
									<div
										v-for="(reserves, index) in reservesDealOrigin"
										:key="index"
										class="content-target-list"
										:class="{ active: selectedFoundOrigin === reserves && activeOrigin}"
										:style="reservesDealOrigin.length === 1 ? { borderRadius: '4px' } : {}"
										@click="handleSelecOrigin(reserves)"
									>
										<div
											class="id-target"
											@mouseenter="handleMouseEnter(index)"
											@mouseleave="handleMouseLeave"
										>
											<span>{{ reserves?.unit?.number }}</span>
											<div v-if="activeTooltip === index && reserves?.unit?.number.length > 4" class="tooltip-number">{{ reserves.unit.number }}</div>
										</div>

										<div class="data-target">
											<span class="name-target">{{ reserves?.unit?.availability?.name }}</span>
											<span class="content-target">
												{{ reserves?.unit?.availability?.type == 'horizontal' ? 'Quadra' : 'Bloco' }} {{ reserves?.unit?.block }} -
												{{ reserves?.unit?.availability?.type == 'horizontal' ? `Lote ${reserves?.unit?.number }` : `Andar ${reserves?.unit?.floor}` }} -
												{{ reserves?.unit?.area }} m² - {{ reserves?.unit?.cost | currencyBRL }}
											</span>
										</div>

										<div v-if="reserves.transferReserveloadingOrigin" class="transfer-reserve-loading">
											<ui-load-indicator bg-color="#D1CFDF" color="#0091FF" :h="20" :stroke="6" />

											<span>Transferindo...</span>
										</div>

										<div v-if="reserves.transferReserveSuccessOrigin" class="transfer-reserve-success">
											<em class="fal fa-check" />
										</div>
									</div>
								</div>
							</div>

							<div v-if="reservesDealOrigin.length == 0 && !loadingOriginSelected" class="selected-business">
								<span v-if="hasOriginReserves">Você precisa selecionar um Negócio.</span>
							</div>
						</template>

						<template #targetAction>
							<div v-if="!hasBusinessTarget" class="container-origin-target-action">
								<ui-input
									type="text"
									size="md"
									placeholder="Digite nome, e-mail, telefone ou CPF do cliente"
									v-model="form.nameTarget"
									@keyup.enter="checkDuplicityTarget()"
								/>

								<em v-if="!loadingTarget" class="fal fa-search search-origin" @click="checkDuplicityTarget()" />

								<div v-if="loadingTarget" class="loading-area-origin">
									<ui-load-indicator bg-color="#D1CFDF" color="#0091FF" :h="20" :stroke="6" />
								</div>
							</div>


							<div v-if="requiredTarget && !hasBusinessTarget" class="container-select">
								<div class="container-select-deal-found scroll-color-primary">
									<div
										v-for="(data, index) in customersDuplicityFoundTarget"
										:key="index"
										class="found"
										@click="handleSelectedFoundTarget(data)"
									>
										<span class="id-name">{{ data.id }} - {{ data.customer_name }}</span>
										<span v-if="data.customer_cpf" class="cpf">CPF: {{ data.customer_cpf ? formatedCPF(data.customer_cpf) : '-' }}</span>
									</div>
								</div>
							</div>

							<div v-if="hasBusinessTarget" class="container-select-deal">
								<div class="id-name-cpf">
									<span class="id-name">{{ isSelectedTarget.id }} - {{ isSelectedTarget.customer_name }}</span>
									<span v-if="isSelectedTarget.customer_cpf" class="cpf">CPF: {{ isSelectedTarget.customer_cpf ? formatedCPF(isSelectedTarget.customer_cpf) : '-' }}</span>
								</div>

								<span
									class="alter"
									:class="{ 'disabled': isDisabledTarget }"
									@click="alterFoundTarget"
								>
									Alterar
								</span>
							</div>

							<div v-if="reservesDealTarget.length > 0" class="has-reserves">
								<span class="text-has-reserves">
									Encontramos {{ reservesDealTarget.length }} {{ reservesDealTarget.length > 1 ? 'reservas' : 'reserva' }}
								</span>
							</div>

							<div v-if="!hasTargetReserves" class="has-reserves">
								<span class="text-has-reserves">
									Nenhuma reserva encontrada.
								</span>
							</div>
						</template>

						<template #targetLists>
							<div v-if="loadingTargetSelected" class="loading-area">
								<ui-load-indicator bg-color="#D1CFDF" color="#69D296" :h="50" :stroke="8" />
							</div>

							<div v-if="reservesDealTarget.length > 0 && !loadingTarget"  class="container-scroll">
								<div class="container-target-list scroll-color-primary">
									<div
										v-for="(reserves, index) in reservesDealTarget"
										:key="index"
										class="content-target-list"
										:class="{ active: selectedFoundTarget === reserves && activeTarget }"
										:style="reservesDealTarget.length === 1 ? { borderRadius: '4px' } : {}"
										@click="handleSelecTarget(reserves)"
									>
										<div
											class="id-target"
											@mouseenter="handleMouseEnterTarget(index)"
											@mouseleave="handleMouseLeaveTarget"
										>
											<span>{{ reserves.unit.number }}</span>
											<div v-if="activeTooltipTarget === index && reserves.unit.number.length > 4" class="tooltip-number">{{ reserves.unit.number }}</div>
										</div>

										<div class="data-target">
											<span class="name-target">{{ reserves.unit.availability.name }}</span>
											<span class="content-target">
												{{ reserves?.unit?.availability?.type == 'horizontal' ? 'Quadra' : 'Bloco' }} {{ reserves?.unit?.block }} -
												{{ reserves?.unit?.availability?.type == 'horizontal' ? `Lote ${reserves?.unit?.number }` : `Andar ${reserves?.unit?.floor}` }} -
												{{ reserves?.unit?.area }} m² - {{ reserves?.unit?.cost | currencyBRL }}
											</span>
										</div>

										<div v-if="reserves.transferReserveloadingTarget" class="transfer-reserve-loading">
											<ui-load-indicator bg-color="#D1CFDF" color="#0091FF" :h="20" :stroke="6" />

											<span>Transferindo...</span>
										</div>

										<div v-if="reserves.transferReserveSuccessTarget" class="transfer-reserve-success">
											<em class="fal fa-check" />
										</div>
									</div>
								</div>
							</div>

							<div v-if="reservesDealTarget.length == 0 && !loadingTargetSelected" class="selected-business">
								<span v-if="hasTargetReserves">Você precisa selecionar um Negócio.</span>
							</div>
						</template>
					</ui-transfer-list>
				</div>

				<span class="footer-text-transfer-reservations">
					Ao transferir uma reserva, ela será cancelada para o negócio de origem e, logo após, <br> será realizada uma nova reserva para o negócio de destino.
				</span>
			</div>
		</template>
	</panel-template>
</template>

<script>
import { uiBreadcrumbs, uiLoadIndicator } from '@/components/ui'
import { uiInput } from '@/components/ui/form'
import uiTransferList from '@/components/ui/transfer-list'
import { currencyBRL } from '@/filters'
import { alertMixin, helpersMixin } from '@/mixins'
import { availabilityTransfer, openSearch, reserve } from '@/services/axios'
import { storage } from '@/services/storage'
import PanelTemplate from '@/templates/page-panel-center'
import axios from 'axios'

const defaultForm = () => ({
	nameOrigin: '',
	nameTarget: '',
})

export default {
	name: 'transfer-reservations',

	filters: {
		currencyBRL,
	},

	components: {
		uiBreadcrumbs,
		PanelTemplate,
		uiTransferList,
		uiInput,
		uiLoadIndicator,
	},

	mixins: [alertMixin, helpersMixin],

	data() {
		return {
			loadingOrigin: false,
			loadingTarget: false,
			form: { ...defaultForm() },
			abortToken: null,
			customersDuplicityFound: [],
			required: false,
			isSelectedOrigin: {},
			hasBusinessOrigin: false,
			reservesDealOrigin: [],
			customersDuplicityFoundTarget: [],
			requiredTarget: false,
			isSelectedTarget: {},
			reservesDealTarget: [],
			hasOriginReserves: true,
			hasTargetReserves: true,
			hasBusinessTarget: false,
			activeRightAction: false,
			activeLeftAction: false,
			selectedFoundOrigin: null,
			selectedFoundTarget: null,
			actionsDisableLeft: false,
			actionsDisableRight: false,
			actionsDisable: false,
			isDisabledOrigin: false,
			isDisabledTarget: false,
			activeTarget: false,
			activeOrigin: false,
			loadingOriginSelected: false,
			loadingTargetSelected: false,
			loadOverlay: false,
			activeTooltip: null,
			activeTooltipTarget: null
		}
	},

	watch: {
		'form.nameOrigin': {
			handler(newValue) {
				this.$emit('input', newValue)
				this.required = false
			},

			deep: true,
		},
		'form.nameTarget': {
			handler(newValue) {
				this.$emit('input', newValue)
				this.requiredTarget = false
			},

			deep: true,
		}
	},

	computed: {
		user() {
			return JSON.parse(storage.get('user_logged'))
		},

		getDealId() {
			return this.$route?.query?.negocio
		},

		getReserveId() {
			return this.$route?.query?.reserva
		},
		getTransferReservesActive() {
			return JSON.parse(storage.get('transfer-reserves'))
		},
	},

	mounted() {
		if (!this.getTransferReservesActive.active) {
			this.$router.back()
		}

		if (this.user?.user_group !== 'admin') {
			this.$router.push({ name: 'products.list' })
		}

		if (this.getDealId) this.foundOriginUnitsReserves(this.getDealId)
	},

	beforeDestroy() {
		this.$root.$off('origin-deal--verify-deal-name')
	},

	methods: {
		handleMouseEnterTarget(index) {
			this.activeTooltipTarget = index
		},

		handleMouseLeaveTarget() {
			this.activeTooltipTarget = null
		},

		handleMouseEnter(index) {
			this.activeTooltip = index
		},

		handleMouseLeave() {
			this.activeTooltip = null
		},

		openCardFound() {
			this.required = true
		},

		openCardFoundTarget() {
			this.requiredTarget = true
		},

		closeCardFound() {
			this.required = false
		},

		closeCardFoundTarget() {
			this.requiredTarget = false
		},

		async checkDuplicity(toFind) {
			if (toFind) {
				this.loadOverlay = true
				this.form.nameOrigin = toFind
			}

			if (this.abortToken) this.abortToken.cancel()

			if (!this.form.nameOrigin || this.form.nameOrigin == '') {
				// Stop duplicity check loading warning
				this.loadingOrigin = false

				// Close card
				this.closeCardFound()

				return
			}

			// Axios 0.22 introduced the new https://developer.mozilla.org/en-US/docs/Web/API/AbortController
			// and made CancelToken deprecated. The facilita system is still using axios 0.19 so i will have to use CancelToken...
			this.abortToken = axios.CancelToken.source()

			try {
				// Start duplicity check loading warning
				this.loadingOrigin = true
				this.customersDuplicityFound = []
				let dealId = null

				const response = await openSearch.searchReserves(this.form.nameOrigin, this.getInstance(), this.abortToken.token, true)
				const data = response.data.hits.hits

				if (data.length <= 0) {
					// Close card
					this.closeCardFound()

					return
				}

				// Filtrar apenas os que NÃO estão no conjunto de IDs já existentes
				this.customersDuplicityFound = data
					.map(item => item._source)
					.filter(item => this.isSelectedTarget.id != item.id)

				if (this.getDealId != '') {
					dealId = this.customersDuplicityFound
					dealId = this.customersDuplicityFound.find(deal => deal.id == this.getDealId)
					this.handleSelectedFound(dealId)
				}

				this.openCardFound()

				// Stop duplicity check loading warning
				this.$mx_alertSuccess(response.data.msg)
			} finally {
				this.loadingOrigin = false
				this.loadOverlay = false
			}
		},

		async checkDuplicityTarget() {
			if (this.abortToken) this.abortToken.cancel()

			if (!this.form.nameTarget || this.form.nameTarget == '') {
				// Stop duplicity check loading warning
				this.loadingTarget = false

				// Close card
				this.closeCardFoundTarget()

				return
			}

			// Axios 0.22 introduced the new https://developer.mozilla.org/en-US/docs/Web/API/AbortController
			// and made CancelToken deprecated. The facilita system is still using axios 0.19 so i will have to use CancelToken...
			this.abortToken = axios.CancelToken.source()

			try {
				// Start duplicity check loading warning
				this.loadingTarget = true
				this.customersDuplicityFoundTarget = []

				const response = await openSearch.searchReserves(this.form.nameTarget, this.getInstance(), this.abortToken.token)
				const data = response.data.hits.hits

				if (data.length <= 0) {
					// Close card
					this.closeCardFoundTarget()

					return
				}

				// Filtrar apenas os que NÃO estão no conjunto de IDs já existentes
				this.customersDuplicityFoundTarget = data
					.map(item => item._source)
					.filter(item => this.isSelectedOrigin.id != item.id)

				this.openCardFoundTarget()

				this.$mx_alertSuccess(response.data.msg)
			} finally {
				this.loadingTarget = false
			}
		},

		async handleSelectedFound(found) {
			this.hasOriginReserves = true
			this.isSelectedOrigin = found
			if (this.isSelectedOrigin.id) {
				this.required = false
				this.hasBusinessOrigin = true
				await this.foundOriginUnitsReserves(this.isSelectedOrigin.id)
			} else this.hasBusinessOrigin = false
		},

		async handleSelectedFoundTarget(found) {
			this.hasTargetReserves = true
			this.isSelectedTarget = found
			if (this.isSelectedTarget.id) {
				this.requiredTarget = false
				this.hasBusinessTarget = true
				await this.foundTargetUnitsReserves(this.isSelectedTarget.id)
			} else this.hasBusinessTarget = false
		},

		async foundOriginUnitsReserves(id) {
			let reservesId = null
			this.loadingOrigin = true
			this.loadingOriginSelected = true
			try {
				const response = await reserve.getUnitsReservesDeal(id, {
					where: 'status:reserved',
					whereHas: 'unit.availability.product',
					with: 'deal.customer',
					select: `deal:id,customer_id;deal.customer:id_customer,name`
				})

				if (response?.data?.data[0]?.deal) {
					this.isSelectedOrigin.id = response.data.data[0].deal.id
					this.isSelectedOrigin.customer_name = response.data.data[0].deal.customer.name
					this.hasBusinessOrigin = true
				}

				this.reservesDealOrigin = response.data.data
				this.hasOriginReserves = this.reservesDealOrigin.length > 0 ? true : false

				if (this.getReserveId !== '') {
					const seen = new Set() // Armazena IDs únicos
					const filteredReserves = []

					this.reservesDealOrigin.forEach(reserve => {
						if (!seen.has(reserve.id)) {
							seen.add(reserve.id)
							filteredReserves.push(reserve)
						}
					})

					this.reservesDealOrigin = filteredReserves // Atualiza a lista sem duplicatas

					// Move o item selecionado para o primeiro lugar, se existir
					const index = this.reservesDealOrigin.findIndex(reserve => reserve.id == this.getReserveId)
					if (index > 0) {
						const selectedReserve = this.reservesDealOrigin.splice(index, 1)[0]
						this.reservesDealOrigin.unshift(selectedReserve)

						this.handleSelecOrigin(selectedReserve)
					}
				}
			} catch (error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				}
			} finally {
				this.loadingOrigin = false
				this.loadingOriginSelected = false
			}
		},

		async foundTargetUnitsReserves(id) {
			this.loadingTargetSelected = true
			this.loadingTarget = true
			try {
				const response = await reserve.getUnitsReservesDeal(id, {
					where:'status:reserved',
					whereHas:'unit.availability.product'
				})
				this.reservesDealTarget = response.data.data
				this.hasTargetReserves = this.reservesDealTarget.length > 0 ? true : false

				if (this.selectedFoundOrigin.id != '') {
					this.activeLeftAction = true
				}
			} catch (error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				}
			} finally {
				this.loadingTarget = false
				this.loadingTargetSelected = false
			}
		},

		handleSelecOrigin(reserve) {
			if (this.selectedFoundOrigin == reserve) {
                this.selectedFoundOrigin = null
                this.activeRightAction = false
                this.actionsDisableLeft = false
			} else {
				this.selectedFoundOrigin = reserve
                this.activeRightAction = true
                this.actionsDisableLeft = true
				this.activeOrigin = true
			}
		},

		handleSelecTarget(reserve) {
			if (this.selectedFoundTarget == reserve) {
                this.selectedFoundTarget = null
                this.activeLeftAction = false
                this.actionsDisableRight = false
			} else {
				this.selectedFoundTarget = reserve
                this.activeLeftAction = true
                this.actionsDisableRight = true
				this.activeTarget = true
			}
		},

		async handleToRightAction() {
			if (Object.values(this.isSelectedTarget).every(value => !value)) {
				this.$mx_alertError('Você precisa selecionar um negócio de destino')
			}

			if (!this.reservesDealOrigin) return
			if (this.reservesDealOrigin && this.isSelectedTarget.id) {
				const index = this.reservesDealOrigin.findIndex(item => item.id === this.selectedFoundOrigin.id)

				if (index !== -1) {
					const [ removedItem ] = this.reservesDealOrigin.splice(index, 1)
					const originalIndex = index

					this.$set(removedItem, 'transferReserveloadingTarget', true)

					this.reservesDealTarget.unshift(removedItem)
					try {
						this.actionsDisable = true
						this.hasTargetReserves = true
						this.isDisabledOrigin = true
						this.isDisabledTarget = true

						const response = await availabilityTransfer.postAvailabilityTransferReserves(
							this.selectedFoundOrigin.id,
							{ deal_id: this.isSelectedTarget.id }
						)

						if (response.data.data.id) {
							this.$set(removedItem, 'id', response.data.data.id)
						}

						this.$set(removedItem, 'transferReserveloadingTarget', false)
						this.$set(removedItem, 'transferReserveSuccessTarget', true)
						this.$mx_alertSuccess(response.data.msg)

						setTimeout(() => {
							this.$set(removedItem, 'transferReserveSuccessTarget', false)
						}, 3000)
					} catch (error) {
						if (error.data?.msg) {
							this.$mx_alertError(error.data.msg)
						}

						const targetIndex = this.reservesDealTarget.findIndex(item => item.id === removedItem.id)
						if (targetIndex !== -1) {
							this.reservesDealTarget.splice(targetIndex, 1)
						}
						this.reservesDealOrigin.splice(originalIndex, 0, removedItem)
					} finally {
						this.actionsDisable = false
						this.isDisabledOrigin = false
						this.isDisabledTarget = false
					}

					this.activeRightAction = false
                    this.actionsDisableLeft = false
					this.selectedFoundOrigin = null
					this.hasOriginReserves = this.reservesDealOrigin.length > 0 ? true : false
					this.hasTargetReserves = this.reservesDealTarget.length > 0 ? true : false
					this.selectedFoundTarget = null
				}
			}
		},

		async handleToLeftAction() {
			if (Object.values(this.isSelectedOrigin).every(value => !value)) {
				this.$mx_alertError('Você precisa selecionar um negócio de destino')
			}
			if (!this.reservesDealTarget) return
			if (this.reservesDealTarget  && this.isSelectedOrigin.id) {
				const index = this.reservesDealTarget.findIndex(item => item.id === this.selectedFoundTarget.id)

				if (index !== -1) {
					const [ removedItem ] = this.reservesDealTarget.splice(index, 1)
					const originalIndex = index

					this.$set(removedItem, 'transferReserveloadingOrigin', true)

					this.reservesDealOrigin.unshift(removedItem)

					try {
						this.actionsDisable = true
						this.hasOriginReserves = true
						this.isDisabledTarget = true
						this.isDisabledOrigin = true

						const response = await availabilityTransfer.postAvailabilityTransferReserves(
							this.selectedFoundTarget.id,
							{ deal_id: this.isSelectedOrigin.id }
						)

						if (response.data.data.id) {
							this.$set(removedItem, 'id', response.data.data.id)
						}

						this.$set(removedItem, 'transferReserveloadingOrigin', false)
						this.$set(removedItem, 'transferReserveSuccessOrigin', true)
						this.$mx_alertSuccess(response.data.msg)

						setTimeout(() => {
							this.$set(removedItem, 'transferReserveSuccessOrigin', false)
						}, 3000)
					} catch (error) {
						if (error.data?.msg) {
							this.$mx_alertError(error.data.msg)
						}

						const originIndex = this.reservesDealOrigin.findIndex(item => item.id === removedItem.id)
						if (originIndex !== -1) {
							this.reservesDealOrigin.splice(originIndex, 1)
						}
						this.reservesDealTarget.splice(originalIndex, 0, removedItem)
					} finally {
						this.actionsDisable = false
						this.isDisabledTarget = false
						this.isDisabledOrigin = false
					}
                    this.activeLeftAction = false
                    this.actionsDisableRight = false
					this.selectedFoundTarget = null
					this.hasTargetReserves = this.reservesDealTarget.length > 0 ? true : false
					this.hasOriginReserves = this.reservesDealOrigin.length > 0 ? true : false
				}
			}
		},

		alterFound() {
			this.customersDuplicityFound = []
			this.reservesDealOrigin = []
			this.hasBusinessOrigin = false
			this.hasOriginReserves = true
			this.form.nameOrigin = ''
			this.activeRightAction = false
			this.activeLeftAction = false
			this.selectedFoundOrigin = null
			this.actionsDisableLeft = false
			this.actionsDisableRight = false
			this.isSelectedOrigin = {}
			this.activeTarget = false
			this.$router.push({ query: { negocio: '', reserva: '' } })
		},

		alterFoundTarget() {
			this.customersDuplicityFoundTarget = []
			this.reservesDealTarget = []
			this.hasBusinessTarget = false
			this.hasTargetReserves = true
			this.form.nameTarget = ''
			this.activeRightAction = false
			this.activeLeftAction = false
			this.selectedFoundTarget = null
			this.actionsDisableLeft = false
			this.actionsDisableRight = false
			this.isSelectedTarget = {}
			this.activeOrigin = false
		},

		formatedCPF(value) {
			if (!value || value == '' || Array.isArray(value)) {
				return null
			}

			value = value.replace(/[^\d]/g, '')
			return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
		}
	},
}
</script>

<style lang="stylus" scoped>
@import 'styles.styl'
</style>